import { useState, useEffect } from 'react'
import { Fade, LinearProgress, Typography } from '@mui/material'

const defaultSayings = [
  'Processing your request...',
  'Retrieving the latest data...',
  'Gathering information...',
  'Checking system status...',
  'Ensuring accuracy...',
  'Preparing your workspace...',
  'Loading information...',
  'Fetching records...',
  'Synchronizing data...',
  'Confirming details...',
  'Almost finished...',
]

const ExcruciatinglyIndeterminateProgress = ({
  loading,
  sayings = defaultSayings,
}: {
  loading: boolean
  sayings?: string[]
}) => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!loading) return
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % sayings.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [sayings.length, loading])

  return (
    <Fade in={loading} timeout={500} unmountOnExit>
      <div className="block text-center">
        <LinearProgress
          classes={{
            bar: 'rounded-full h-1',
            root: 'h-1 rounded-full bg-gray-200 mb-2',
          }}
        />
        <Typography variant="body2">{sayings[index]}</Typography>
      </div>
    </Fade>
  )
}

export default ExcruciatinglyIndeterminateProgress
